import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { provideApi } from '../generated';
import { environment } from '../environments/environment';
import { bffSessionApiInterceptor, provideBffSessionAuth } from 'shared-services';
import { provideMarkdown } from 'ngx-markdown';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
      // withDebugTracing()
    ),
    provideHttpClient(
      withInterceptors([bffSessionApiInterceptor(environment.apiBaseUrl)])
    ),
    provideApi({
      basePath: environment.apiBaseUrl,
    }),
    provideBffSessionAuth({
      loginUrl: environment.edriveLoginUrl,
      logoutUrl: environment.edriveLogoutUrl,
    }),
    provideMarkdown(),
  ]
};
